import './styles/EmptyState.scss';

import { PropsWithChildren } from 'react';

import { useClassHelper } from '../../../hooks';

export interface EmptyStateProps extends Partial<PropsWithChildren> {
  title?: string;
}

const componentName = 'c-EmptyState';

export const EmptyState = (props: EmptyStateProps) => {
  const c = useClassHelper(componentName);

  return (
    <article className={componentName}>
      {props.title && <h2 className={c('title')}>{props.title}</h2>}
      {props.children && <div className={c('content')}>{props.children}</div>}
    </article>
  );
};
